<form class="f-col blank-form">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.omfenablecompanylogin']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span> </h2>
    </div>

    <div class="section-content">

        <!-- Normal State -->
        <div class="inner-contentsection" *ngIf="!isFederated">
            <div class="feature-header">
                <h4 class="subheading">{{content?.['b2b.managecompany.omfcompanyloginsetting']}}</h4>
                <a tabindex="0" role="button" target="_blank" (keydown.enter)="openModal()" (click)="openModal()">{{content?.['b2b.managecompany.enable']}}</a>
            </div>
            <p>{{content?.['b2b.managecompany.omfcompanyloginsettingdesc1']}}</p>
            <p>{{content?.['b2b.managecompany.omfcompanyloginsettingdesc2']}}</p>
        </div>

        <!-- Federated State -->
        <div class="inner-contentsection" *ngIf="isFederated">
            <div class="feature-header">
                <h4 class="subheading">{{content?.['b2b.managecompany.omffedaratelogintitle']}}</h4>
            </div>
            <p>
                {{ getFederatedDescriptionParts().part1 }}
                <a routerLink="/Help-Center/help-and-support" class="help-support-link">{{ getFederatedDescriptionParts().part2 }}</a>
            </p>
        </div>
        
    </div>
</form>